import { useLocation } from "react-router-dom";
import "./Platform.css";
import galleryImage from "../../assets/bgimg.jpg";
import heroBg from "../../assets/hero-bg.png"; 


// Import the single brochure for all cities
import brochure from "../../assets/CredtechBrochure.pdf";

const PlatformComponent = () => {
  const location = useLocation();

  // Get city from location state, with default
  const eventCity = location.state?.city || "Hyderabad";

  // Set date based on city
  const getEventDate = (city) => {
    const dates = {
      Hyderabad: "July 25, 2025",
      Pune: "April 4, 2025",
      Chennai: "February 7, 2025",
    };
    return dates[city] || "July 25, 2025";
  };

  const eventDate = location.state?.date || getEventDate(eventCity);

  // Function to handle brochure download
  const handleDownloadBrochure = () => {
    const link = document.createElement("a");
    link.href = brochure;
    link.download = `CREDTECH-Brochure.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // City-specific content
  const getEventContent = (city, date) => {
    switch (city) {
      case "Pune":
        return {
          about: {
            content: (
              <>
                <p>
                  The CREDTECH Knowledge Platform hosted its Pune Chapter on{" "}
                  {date}, at The Ritz-Carlton, Pune. With the theme "Shaping the
                  Future of Commercial Real Estate & Workspaces – Vision 2030,"
                  this edition convened senior decision-makers, thought leaders,
                  and innovators across Commercial Real Estate (CRE), Facilities
                  Management (FM), and Workplace Transformation.
                </p>
                <p>
                  The gathering served as a high-level forum for sharing
                  insights, exchanging ideas, and spotlighting best practices
                  that are shaping the future of workplaces and real estate
                  ecosystems.
                </p>
              </>
            ),
          },
          programme: {
            content: (
              <p>
                The evening began with a traditional lamp-lighting ceremony,
                symbolizing knowledge and collaboration. This was followed by a
                keynote address by Mr. Venkat Neelakantan, powered by
                Technogreen, which set the tone for the discussions. The keynote
                highlighted how sustainability, technology, and evolving
                workforce dynamics will define the next phase of CRE and
                workplace strategies.
              </p>
            ),
          },
          panels: [
            {
              title:
                "Panel 1: An Intersperse of Technology and Design – Visualization 2030",
              subtitle: "Powered by Nestlé Professional",
              details: (
                <>
                  <p>
                    <strong>· Moderator:</strong> Venkat Neelakantan
                  </p>
                  <p>
                    <strong>· Speakers:</strong> Romeet K Kaul, Ekta Acharya,
                    Deben Moza (FRICS, MCA), Zainab Mukadam, Anirudh
                    Sundareshwar
                  </p>
                  <p>
                    <strong>· Key Insights:</strong> The panel explored how
                    innovation, smart technologies, and human-centered design
                    will merge to create adaptable and future-ready workplaces.
                  </p>
                </>
              ),
            },
            {
              title:
                "Panel 2: Pune – A Rising Hub for Global Capability Centres",
              subtitle: "Powered by SSL & Encore Events & Promotions",
              details: (
                <>
                  <p>
                    <strong>· Moderator:</strong> Nitin Deshpande
                  </p>
                  <p>
                    <strong>· Speakers:</strong> Nitin Arora, Fancy George,
                    Ramprasad Santhanagopalan, K.S. Prashant, Piyush Kedia, Alok
                    Kumar
                  </p>
                  <p>
                    <strong>· Key Insights:</strong> This discussion highlighted
                    Pune's rapid rise as a Global Capability Centre (GCC)
                    destination, analyzing factors such as infrastructure
                    readiness, talent pool availability, cost advantages, and
                    its growing role in the global business ecosystem.
                  </p>
                </>
              ),
            },
            {
              title:
                "Panel 3: Electric Vehicles – The Benefits That Matter to You",
              details: (
                <>
                  <p>
                    <strong>· Moderator:</strong> Srinivasa Prasad Vemuru
                  </p>
                  <p>
                    <strong>· Speakers:</strong> Ashish Ranjan Mohanty, Sridhar
                    Chari, Ujjalkumar Banerjee, Aarthi, Abhishek Tibrewala
                  </p>
                  <p>
                    <strong>· Key Insights:</strong> The session examined the
                    adoption of electric mobility, discussing policy frameworks,
                    infrastructure challenges, and the impact of EVs on
                    corporate sustainability strategies and commercial transport
                    systems.
                  </p>
                </>
              ),
            },
          ],
          recognition: {
            content: (
              <>
                <p>
                  A special Awards Segment recognized excellence and best
                  practices in CRE and FM, spotlighting leaders who are driving
                  meaningful change in the industry.
                </p>
                <p>
                  To add a personal touch, the evening also featured a birthday
                  celebration for attendees born in April, creating a sense of
                  community among industry peers.
                </p>
              </>
            ),
          },
          partners: {
            content: (
              <>
                <p>
                  The success of the Pune Chapter was made possible through the
                  support of our valued partners and sponsors, whose
                  contributions enabled a seamless and engaging experience.
                </p>
                <p>
                  <strong>Key Partners:</strong> This edition was supported by
                  leading partners who made the experience possible: Nestlé
                  Professional, Technogreen, Beverich – A Brand of Pranav
                  Enterprises, ParkMe, Diversey, Rush, Encore Events &
                  Promotions, and others.
                </p>
              </>
            ),
          },
          lookingAhead: {
            content: (
              <>
                <p>
                  Building on the success of the Pune edition, the CREDTECH
                  Knowledge Platform is preparing to host many more of these
                  platforms. These future editions will continue to:
                </p>
                <ul>
                  <li>
                    Foster collaboration and dialogue among industry leaders
                  </li>
                  <li>Showcase innovative practices and solutions</li>
                  <li>
                    Provide a platform to redefine the future of workplaces,
                    mobility, and sustainability
                  </li>
                </ul>
                <p>
                  Stay connected with CREDTECH to be part of this ongoing
                  journey that is reshaping the future of Commercial Real Estate
                  and Workspaces – Vision 2030 and beyond.
                </p>
              </>
            ),
          },
        };

      case "Chennai":
        return {
          about: {
            content: (
              <>
                <p>
                  The CREDTECH Knowledge Platform successfully hosted its
                  Chennai Chapter on {date}, with the theme "Shaping Vision
                  2030." Held in the presence of senior decision-makers,
                  industry experts, and innovators, the platform served as a
                  forum to discuss the future of Commercial Real Estate (CRE),
                  Workspaces, and Sustainability.
                </p>
                <p>
                  The chapter provided a stage for insightful dialogue on
                  India's evolving office real estate landscape, the role of
                  emerging technologies, and the importance of building
                  sustainability-driven strategies that will define the
                  workplaces of tomorrow.
                </p>
              </>
            ),
          },
          programme: {
            content: null,
          },
          panels: [
            {
              title:
                "Panel Discussion: Decoding India's Office Real Estate Revolution",
              details: (
                <>
                  <p>
                    <strong>· Speakers:</strong> Kanchana Krishnan, Himanshu
                    Sharma, Ritu Sandhu Sharma, Y S Sunil Reddy, Venkat
                    Neelakantan, Vaibhav Kamdhar
                  </p>
                  <p>
                    <strong>· Focus:</strong> Analyzing market trends, tenant
                    expectations, and the shifting dynamics of India's office
                    real estate sector.
                  </p>
                </>
              ),
            },
            {
              title: "Expert Speak: Sustainability Roadmap 2030",
              details: (
                <>
                  <p>
                    <strong>· Speaker:</strong> Venkat Neelakantan
                  </p>
                  <p>
                    <strong>· Focus:</strong> Practical frameworks for embedding
                    sustainability and eco-conscious practices into real estate
                    strategies.
                  </p>
                </>
              ),
            },
            {
              title:
                "Panel Discussion: Sustainability Roadmap 2030 – An Outlook",
              details: (
                <>
                  <p>
                    <strong>· Speakers:</strong> A Shankar (MRICS, FITP, FIIA),
                    Anupama Mohanram, Deepa Sathiaram, Julian Francis (MRICS,
                    FMP), V Narayanan (MRICS, MCR.w), Sunil David
                  </p>
                  <p>
                    <strong>· Focus:</strong> Best practices, challenges, and
                    solutions for advancing sustainability in commercial real
                    estate and workplace management.
                  </p>
                </>
              ),
            },
          ],
          recognition: {
            content: (
              <p>
                The Chennai Chapter also hosted a recognition segment,
                celebrating individuals and organizations that have demonstrated
                excellence and innovation in CRE and FM practices.
              </p>
            ),
          },
          networking: {
            content: (
              <p>
                The event fostered valuable networking opportunities, enabling
                participants to engage in meaningful discussions, explore
                synergies, and strengthen partnerships within the industry.
              </p>
            ),
          },
          partners: {
            content: (
              <p>
                The Chennai Chapter was supported by leading organizations whose
                partnership contributed to the success of the platform:
                Panasonic, TIDEL Park Limited, Technogreen, Blue Star Limited,
                RM Engineering Interiors India Pvt. Ltd., Beverich – A Brand of
                Pranav Enterprises.
              </p>
            ),
          },
          lookingAhead: {
            content: (
              <>
                <p>
                  Building on the success of the Chennai edition, the CREDTECH
                  Knowledge Platform is preparing to host many more of these
                  platforms. These future editions will continue to:
                </p>
                <ul>
                  <li>
                    Foster collaboration and dialogue among industry leaders
                  </li>
                  <li>Showcase innovative practices and solutions</li>
                  <li>
                    Provide a platform to redefine the future of workplaces,
                    mobility, and sustainability
                  </li>
                </ul>
                <p>
                  Stay connected with CREDTECH to be part of this ongoing
                  journey that is reshaping the future of Commercial Real Estate
                  and Workspaces – Vision 2030 and beyond.
                </p>
              </>
            ),
          },
        };

      case "Hyderabad":
      default:
        return {
          about: {
            content: (
              <>
                <p>
                  The CREDTECH Knowledge Platform – Hyderabad Chapter was held
                  on {date}, at The Trident Hotel, Hyderabad, bringing together
                  100+ senior leaders and decision-makers from the Corporate
                  Real Estate (CRE), Facilities Management (FM), Workplace
                  Strategy, and Smart Mobility ecosystem.
                </p>
                <p>
                  Themed "Future-Ready Workplaces and Ecosystem Collaboration,"
                  the chapter focused on Hyderabad's emergence as a leading GCC
                  hub, the integration of AI in workplace strategies, the design
                  of next-generation workspaces to meet Gen Z and hybrid
                  workforce needs, and the adoption of sustainable mobility
                  solutions to future-proof corporate ecosystems.
                </p>
              </>
            ),
          },
          programme: {
            content: (
              <ul>
                <li>
                  Lamp-Lighting Ceremony Inaugurated by industry leaders
                  including Ramesh Kaza, Sandip Patnaik, Isaac Rajkumar,
                  Srinivasa Prasad Vemuru, and Prashanth Nandella, alongside
                  Sunanda Jaiprakash.
                </li>
                <li>
                  Keynote Address Delivered by Prashanth Nandella, President of
                  HYSEA, highlighting Hyderabad's GCC trajectory, policy
                  enablers, and academic collaboration for future-ready talent.
                </li>
                <li>
                  Panel 1: Hyderabad – A Rising GCC Hub Speakers: Sandip
                  Patnaik, Simar D Singh, Ramesh Kaza, Isaac Rajkumar, Srinivasa
                  Prasad Vemuru, Vivek S Focus: Hyderabad's strengths,
                  opportunities, and challenges as a global GCC destination.
                </li>
                <li>
                  Fireside Chat: AI at Work Speakers: Venkat Neelakantan &
                  Krishna Prasad Focus: Leveraging Artificial Intelligence to
                  augment human performance in the workplace.
                </li>
                <li>
                  Panel 2: Next-Gen Workspaces – Where Generations & Technology
                  Converge Moderator: Aravind Babu Ramaraju Speakers: Ankur
                  Marda, Pranita Jonnalagedda, Srinivas Taluka, Goutham Gedela
                  Focus: Designing hybrid and inclusive work environments for
                  the workforce of tomorrow.
                </li>
                <li>
                  Fireside Chat: Smart Mobility in Workplaces Speakers: Abhishek
                  Tibrewala, Rajeev YSR, Sushil Kavathekar Focus: The impact of
                  EV adoption and mobility infrastructure on workplace planning.
                </li>
                <li>
                  CREDTECH Best Practices Awards 2025 Recognizing excellence in
                  CRE and FM with awards to organizations such as LTI Mindtree,
                  OpenText, New Relic, and LSR Tudor.
                </li>
              </ul>
            ),
          },
          partners: {
            content: (
              <>
                <p>
                  <strong>Gold Sponsors:</strong> LSR Tudor, Richi Interiors,
                  nhance, dormakaba
                </p>
                <p>
                  <strong>Silver Sponsors:</strong> Tata MyBistro, GoKhana,
                  Shyam Salasar Logistics, 2V Engineering Interiors India Pvt
                  Ltd, ParkMe
                </p>
                <p>
                  <strong>Pavilion Sponsors:</strong> Beverich India,
                  Bolt.Earth, Omega Cabs, Krayons
                </p>
              </>
            ),
          },
          outcomes: {
            content: (
              <ul>
                <li>Reinforced Hyderabad's leadership as a GCC hub.</li>
                <li>
                  Advanced discussions on AI, hybrid workplace strategies, and
                  sustainable mobility.
                </li>
                <li>
                  Showcased best practices in CRE and FM, celebrating impactful
                  contributions.
                </li>
                <li>
                  Strengthened collaborations between industry leaders,
                  policymakers, and solution providers.
                </li>
              </ul>
            ),
          },
          lookingAhead: {
            content: (
              <p>
                Building on the momentum from Hyderabad, the next edition of the
                CREDTECH Knowledge Platform will take place in Bangalore on
                November 7, 2025, at The Leela Palace, continuing to shape
                Vision 2030 for the future of commercial real estate and
                workplaces.
              </p>
            ),
          },
        };
    }
  };

  const baseEventContent = getEventContent(eventCity, eventDate);

  // Create a new content object with dynamic titles
  const eventContent = {
    ...baseEventContent,
    about: {
      ...baseEventContent.about,
      title: `About the Event – ${eventCity} Chapter | ${eventDate}`,
    },
    programme: baseEventContent.programme
      ? {
          ...baseEventContent.programme,
          title: "Programme Overview",
        }
      : null,
  };

  return (
    <div className="platform-container">
      {/* Hero Section */}
      <div className="paltform-gallery-hero" style={{ backgroundImage: `url(${heroBg})` }}>
        <div>
          <h1 className="gallery-title">PLATFORMS</h1>
        </div>
      </div>

      <div className="content-wrapper">
        <div className="platform-text">
          {/* Use dynamic city and date */}
          <h2>
            {eventCity.toUpperCase()} | {eventDate.toUpperCase()}{" "}
          </h2>
        </div>

        {/* About Event Section */}
        <div className="event-overview-section">
          <h3 className="event-overview-title">{eventContent.about.title}</h3>
          <div className="event-description">{eventContent.about.content}</div>
        </div>

        {/* Programme Overview Section */}
        {eventContent.programme && (
          <div className="event-overview-section">
            <h3 className="event-overview-title">
              {eventContent.programme.title}
            </h3>
            <div className="event-description">
              {eventContent.programme.content}
            </div>
          </div>
        )}

        {/* Panels Section */}
        {eventContent.panels && (
          <>
            <div className="event-overview-section">
              <h3 className="event-overview-title">Panel Discussions</h3>
              <div className="event-description">
                <p>
                  The core of the event featured impactful panel discussions,
                  each addressing a critical dimension of the industry's
                  transformation:
                </p>
              </div>
            </div>

            {eventContent.panels.map((panel, index) => (
              <div key={index} className="event-overview-section">
                <h3 className="event-overview-title">{panel.title}</h3>
                {panel.subtitle && (
                  <div className="event-description">
                    <p>{panel.subtitle}</p>
                  </div>
                )}
                <div className="event-description">{panel.details}</div>
              </div>
            ))}
          </>
        )}

        {/* Recognition Section */}
        {eventContent.recognition && (
          <div className="event-overview-section">
            <h3 className="event-overview-title">Recognition & Celebrations</h3>
            <div className="event-description">
              {eventContent.recognition.content}
            </div>
          </div>
        )}

        {/* Networking Section */}
        {eventContent.networking && (
          <div className="event-overview-section">
            <h3 className="event-overview-title">Networking & Collaboration</h3>
            <div className="event-description">
              {eventContent.networking.content}
            </div>
          </div>
        )}

        {/* Partners Section */}
        {eventContent.partners && (
          <div className="event-overview-section">
            <h3 className="event-overview-title">Partners & Sponsors</h3>
            <div className="event-description">
              {eventContent.partners.content}
            </div>
          </div>
        )}

        {/* Outcomes Section */}
        {eventContent.outcomes && (
          <div className="event-overview-section">
            <h3 className="event-overview-title">Key Outcomes</h3>
            <div className="event-description">
              {eventContent.outcomes.content}
            </div>
          </div>
        )}

        {/* Looking Ahead Section */}
        {eventContent.lookingAhead && (
          <div className="event-overview-section">
            <h3 className="event-overview-title">Looking Ahead</h3>
            <div className="event-description">
              {eventContent.lookingAhead.content}
            </div>
          </div>
        )}

        {/* Download Brochure Button */}
        <div className="brochure-btn-section">
          <button className="brochure-btn" onClick={handleDownloadBrochure}>
            Download Brochure
          </button>
        </div>
      </div>
    </div>
  );
};

export default PlatformComponent;
